import { TravelApiInterface } from "@syadem/kairos-citizen-js";
import { ActionResult } from "../../actionResult";
import { TravelRecord, TravelSnapshot } from "../../domain/travel";
import { fromApiTravel, toApiTravel } from "../../network/apis/travelMapper";
import { Service } from "../service";

interface Payload {
  healthRecordId: string;
  travelId: string;
  travel: TravelSnapshot;
}

export class UpdateTravelService implements Service<Payload, TravelRecord> {
  constructor(private readonly travelApi: TravelApiInterface) {}

  async call({ healthRecordId, travelId, travel }: Payload): Promise<ActionResult<TravelRecord>> {
    const record = await this.travelApi.updateTravel(healthRecordId, travelId, { travel: toApiTravel(travel) });

    return {
      type: "success",
      value: fromApiTravel(record),
    };
  }
}
